// Module
var code = "<div>\n\t<button type=\"button\" class=\"btn btn-secondary dropdown-toggle\" data-bind=\"text: buttonText\"></button>\n</div>\n";
// Exports
export default code;